import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { DocumentGetAll } from '../../services';

export const fetchDocumentGetAll = createAsyncThunk(
    'documentGetAll/fetchDocumentGetAll',
    async () => {
        const response = await DocumentGetAll()
        return response.result
    }
);

const documentGetAllSlice = createSlice({
    name: 'documentGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchDocumentGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchDocumentGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchDocumentGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default documentGetAllSlice.reducer;
